<template>
    <div class="page404">
        <h1>Ошибка 404</h1>

        <p class="page404__text">Кажется что-то пошло не&nbsp;так! Страница, которуб вы&nbsp;запрвшиваете, не&nbsp;существует. Возможно она устарела, была удалена, или был введен неверный адрес в&nbsp;адресной строке.</p>

        <button type="button" class="btn btn_primary mt-16" @click="goToMainPage">Перейти на главную</button>
    </div>
</template>

<script>
export default {
    methods: {
        goToMainPage() {
            this.$router.push({ name: 'Main' })
        }
    }
}
</script>